
import * as React from 'react';
import { useEffect, useContext } from 'react';
import { useTranslation } from "react-i18next";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import useMediaQuery from '@mui/material/useMediaQuery';
import ListItemButton from '@mui/material/ListItemButton';
import AddIcon from '@mui/icons-material/Add';
import { SideNavItem } from './SideNavItem';
//import { SideNavSubItem } from './SideNavSubItem';
import Usage from "../components/Usage.jsx";
import logo from "../assets/img/apple.png";
import { AuthContext } from "../context/AuthContext";
import { AppConfigContext } from "../context/AppConfigContext";

export default function SideNav({ userHasNoProject, handleClickOnNewProject, onClose, open, projects, projectSelected, setProjectSelected, usage, maxSpace, GoUploadedThisMonth, maxGoUploadPerMonth }) {
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  const { service } = useContext(AuthContext);
  const { demo } = useContext(AppConfigContext);

  const [selectedindex, setselectedindex] = React.useState(0);

  const {  t } = useTranslation();

  //console.log(projects);

  useEffect(() => {
    if (projectSelected && projectSelected !== undefined) setselectedindex(projectSelected.id);
  }, [projectSelected]);

  const handlelistitemclick = (event, value) => {
    setselectedindex(value.id);
    setProjectSelected(value);
    //console.log(value);
  };

  const handleNewProjectClick = (event) => {
    handleClickOnNewProject();
  };

  let serviceTitle="";
  if(service==="classic")serviceTitle=t("ServiceClassic");
  if(service==="mapping")serviceTitle=t("ServiceMapping");

  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
    >
      <Box sx={{ px: 3, pt: 3, pb: 2 }}>
        <Stack
          direction="row"
          spacing={1.5}
          sx={{ alignItems: 'center' }}
        >
          <Box
            sx={{
              borderRadius: '12px',
              boxShadow: '0 0 20px rgba(1, 116, 190, 0.25)',
              flexShrink: 0,
            }}
          >
            <img
              alt="logo mirukuru"
              width="52px"
              height="52px"
              src={logo}
              style={{ display: 'block', borderRadius: '12px' }}
            />
          </Box>
          <Stack spacing={0}>
            <Typography
              color="inherit"
              variant="h5"
              sx={{ fontWeight: 700, lineHeight: 1.3 }}
            >
              Mirukuru
            </Typography>
            <Typography
              color="neutral.400"
              variant="body1"
            >
              {t("OnlineStorage")}
            </Typography>
          </Stack>
        </Stack>
      </Box>
      <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.08)' }} />
      <Box
        sx={{
          px: 3,
          py: 2
        }}
      >
          <Button
            disabled={demo}
            variant="contained"
            fullWidth
            size="large"
            startIcon={<AddIcon />}
            onClick={(event) => handleNewProjectClick(event)}
            sx={{
              backgroundColor: 'rgba(1, 116, 190, 0.2)',
              color: '#5cb8ff',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: 'rgba(1, 116, 190, 0.35)',
                boxShadow: 'none',
                transform: 'none',
              },
              '&:active': {
                boxShadow: 'none',
                transform: 'none',
              },
              '&.Mui-disabled': {
                backgroundColor: 'rgba(255, 255, 255, 0.06)',
                color: 'rgba(255, 255, 255, 0.25)',
              },
            }}
          >
            {t("NewProject")}
          </Button>
      </Box>
      <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.08)' }} />
      <Box
        component="nav"
        sx={{
          flexGrow: 1,
          overflowY: 'auto',
          px: 2,
          py: 1,
          '&::-webkit-scrollbar': {
            width: '4px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(255, 255, 255, 0.15)',
            borderRadius: '4px',
          },
        }}
      >
        <Typography
          variant="overline"
          sx={{ color: 'neutral.500', px: 1, pb: 0.5 }}
        >
          {t("Projects")}
        </Typography>
        <Stack
          component="ul"
          spacing={0.5}
          sx={{
            listStyle: 'none',
            p: 0,
            m: 0
          }}
        >
          {userHasNoProject &&
            <Typography
              color="text.secondary"
              variant="body1"
              sx={{ p: 1 }}
              style={{ wordWrap: "break-word" }}
            >
              {t("NoProjectYet")}
            </Typography>

          }
          {projects.length > 0 &&
            <>
              {projects.map((item, index) => {
                return (
                  <ListItemButton key={index}
                    onClick={(event) => handlelistitemclick(event, item)}
                  >
                    <Stack>
                    <SideNavItem
                      active={selectedindex === item.id}
                      disabled={item.attributes.disabled}
                      external={item.attributes.external}
                      icon={item.attributes.icon}
                      path={item.attributes.path}
                      title={item.attributes.title}
                      empty={item.attributes.data.data.length}
                    />
                    {/* {item.attributes.data.data.length > 0 &&
                    <>
                      {item.attributes.data.data.map((file, index) => { 
                        return(
                          <SideNavSubItem file={file.attributes} active={selectedindex === item.id} key={index}/>
                        );       
                      })}
                    </>
                    } */}
                    </Stack>
                  </ListItemButton>
                );
              })}
            </>
          }
        </Stack>
      </Box>
      <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.08)' }} />
      <Box sx={{ px: 3, pt: 2, pb: 3 }}>
        <Usage value={usage} max={maxSpace} GoUploadedThisMonth={GoUploadedThisMonth} maxGoUploadPerMonth={maxGoUploadPerMonth}/>
      </Box>
      
      {/* <Box
        sx={{
          px: 3,
          pt: 0
        }}
      >
        <Grid xs item textAlign='center'>
          <Typography
            color="neutral.100"
            variant="subtitle2"
          >
            {t("Needmorespace")}
          </Typography>
          <Typography
            color="neutral.500"
            variant="body2"
          >
            {t("Getintouchwithus")}
          </Typography>
        </Grid>
        <Button
          component="a"
          fullWidth
          onClick={() => window.location.href = 'mailto:contact-user-guest@mirukuru.co.jp'}
          sx={{ my: 2 }}
          target="_blank"
          variant="contained"
        >
          {t("ContactUs")}
        </Button>
      </Box> */}
    </Box>
  );

  if (lgUp) {
    return (
      <Drawer
        anchor="left"
        open
        slotProps={{
          paper: {
            sx: {
              backgroundColor: '#212529',
              color: 'common.white',
              width: 280
            }
          }
        }}
        variant="permanent"
      >
        {content}
      </Drawer>
    );
  }

  return (
    <Drawer
      anchor="left"
      onClose={onClose}
      open={open}
      slotProps={{
        paper: {
          sx: {
            backgroundColor: '#212529',
            color: 'common.white',
            width: 280
          }
        }
      }}
      sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
      variant="temporary"
    >
      {content}
    </Drawer>
  );
};
